import type { BackgroundRemovalProgress } from '../../backgroundRemoval/imageModalBackgroundRemovalProgressTypes';
import type { UserFeatureUsageSummary } from '../../../../../../common/users/userFeatureUsageTypes';

export const IMAGE_MODAL_V2_OPERATION_MESSAGE = {
    REMOVING_BACKGROUND: 'removingBackground',
    SAVING_CHANGES: 'savingChanges',
} as const;

export type ImageModalV2OperationMessage =
    (typeof IMAGE_MODAL_V2_OPERATION_MESSAGE)[keyof typeof IMAGE_MODAL_V2_OPERATION_MESSAGE];

export type ImageModalV2OperationToastState = {
    message: ImageModalV2OperationMessage;
    progress: BackgroundRemovalProgress | null;
    /** Usage captured before the removal started; only set for removing-background toasts. */
    usage?: UserFeatureUsageSummary | null;
};
